import _get from 'lodash/get';

export function createFormData(data = {}) {
  const serviceableDays = _get(data, 'serviceable_days', '');
  return {
    ...data,
    serviceable_days: `${serviceableDays}`
  };
}
